const CheckValidationFormField = (name, value,element,t) => {

    let formIsValid = true;
    let tempErrors = {}; 

    return {tempErrors, formIsValid};

}

export default CheckValidationFormField;